/**
 * Demo credentials for the Skul backend API.
 *
 * The tenant ID is for the seeded 'skul-demo' tenant.
 * Credentials match the backend seed migration (00127).
 */

export const DEMO_TENANT_ID = "019cc44b-a082-7bc3-ae58-ff6592014d59";

export const MOCK_CREDENTIALS = [
  {
    label: "Admin",
    email: "admin@skul.app",
    password: "Admin@123!",
    role: "School Admin",
  },
] as const;
